import styled, {css} from 'styled-components'

const colors = {
    gray: '#C5C6C6',
    blue: '#2C5FF4'
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const HeaderWrapper = styled(Container)`
  height: 100px;
  padding-left: 20px;
  padding-top: 20px;
  background-color: #fff;
`

export const DescriptionWrapper = styled(Container)`
  flex-direction: row;
  height: 40px;
  align-items: center;
`
export const HeaderTitle = styled.label`font-size: 20px;`
export const DescriptionLabel = styled.label`font-size: 13px;
  font-weight: bold;
  margin-left: 10px;`

export const ButtonWrapper = styled(Container)`
  flex-direction: row;
  height: 50px;
  align-items: flex-end;
  justify-content: flex-end;
  background-color: #fff;
`
export const ButtonContainer = styled.button`
  border: 0px;
  height: 50px;
  background-color: ${colors.gray};

  ${({saveButton}) => saveButton ? css` width: 180px;
    padding-right: 100px;` : css`width: 50px;`}
  :hover {
    svg {
      fill: #fff;
    }

    background-color: ${colors.blue};
    cursor: pointer;
    color: #fff
  }
`
